import { render, staticRenderFns } from "./NoShowDetails.vue?vue&type=template&id=2361e838"
import script from "./NoShowDetails.vue?vue&type=script&lang=js"
export * from "./NoShowDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports